import React from 'react';

import { submit } from '../../../AppServices';
import { Form } from '../../../app-components/form/Form';
import { autoSuggestOptionsInput } from '../../../autoSuggestions';
import { MODELS, ROUTES, selectStatus } from '../../../Lib/constants';
import { validateAdminMobile, validateEmail } from '../../../Lib/helpers';
import { EditAdminURI } from '../../../Queries/admin';

const validations = {
  email: ({ data }) => validateEmail(data?.email),
  phonenumber: ({ data }) => validateAdminMobile(data?.phonenumber),
};

const EditAdmin = (props) => (
  <Form
    type="standard"
    uri={EditAdminURI}
    closeView={1}
    reloadEvent={ROUTES.adminData.name}
    reloadOnChangeEvent={ROUTES.adminData.name}
    onSubmit={submit({
      model: MODELS.Admin,
    })}
    validations={validations}
    mandatory={{ status: 1 }}
    submitMessage="Admin Updated Successfully"
    uniqueValidationMessage="Username already exist."
    fieldContainer="topLabel"
    lg={{
      formGroups: [
        {
          columnsPerRow: 2,
          fieldVariant: 'filled',
          groups: [
            {
              columns: [
                {
                  type: 'text',
                  field: 'name',
                  label: 'Admin Name',
                  mandatory: true,
                  allowWhiteSpaces: true,
                  editable: false,
                },
                {
                  type: 'text',
                  field: 'username',
                  label: 'Admin Username',
                  mandatory: true,
                  allowWhiteSpaces: true,
                  editable: false,
                },
                {
                  type: 'text',
                  field: 'phonenumber',
                  label: 'Mobile Number',
                  modifyValueOnChange: ({ prevValue, value }) => {
                    if (value?.toString()?.length > 10) {
                      return prevValue;
                    }
                    return value;
                  },
                  editable: false,
                },
                {
                  type: 'text',
                  field: 'email',
                  label: 'Email Id',
                  mandatory: true,
                  allowWhiteSpaces: false,
                  editable: false,
                },
                autoSuggestOptionsInput({
                  label: 'Status',
                  field: 'status',
                  suggestionField: 'label',
                  valueField: 'label',
                  options: selectStatus,
                  keyField: 'label',
                }),
              ],
            },
          ],
        },
      ],
    }}
    {...props}
  />
);

export default EditAdmin;
